import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { Field } from '../../../_models/field';
import { UserProfile } from '../../../_models/user-profile';
import { PortalApiService } from '../../../_services/portal-api.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { UserProfileService } from '../../../_services/user-profile.service';

@Component({
  selector: 'app-view-tank-gauges',
  templateUrl: './view-tank-gauges.component.html',
  styleUrls: ['./view-tank-gauges.component.css']
})
export class ViewTankGaugesComponent implements OnInit, OnDestroy {
  entryDate: string;
  isLoading: boolean = false;

  // Top Bar component
  isLoadingField: boolean = false;
  field: Field;
  userProfile: UserProfile;
  fieldID: number;
  // Errors
  errorGetField: string;

  // Subjects
  private onDestroy$ = new Subject<void>();

  constructor(
    private apiService: PortalApiService,
    private route: ActivatedRoute,
    private userService: UserProfileService
  ) {
    this.userService.userProfile$.pipe(takeUntil(this.onDestroy$)).subscribe(
      userProfile => {
        this.userProfile = userProfile;
      });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.fieldID = params['fieldID'];
      this.entryDate = params['entryDate'];
    });

    this.getFields();
  }


  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  getFields() {
    this.isLoadingField = true;

    if (this.userProfile.id) {
      this.apiService.getFields().subscribe(
        (data: Field[]) => {
          //console.log(data);
          this.isLoadingField = false;

          data.map(field => {
            if (field.fieldID == this.fieldID) {
              this.field = field;
            }
          })
        },
        err => {
          console.log(err);
          this.errorGetField = (err.error || 'An error occurred. Failed to load field.');
          this.isLoadingField = false;
        }
      );
    }
  }
}
